import { authorizedFetch } from './api-client';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export interface SendBookingInviteRequest {
  clinic_id: string;
  cellphone: string;
  patient_id: string;
  specialty_id?: string;
}

export interface SendRebookingInviteRequest {
  clinic_id: string;
  cellphone: string;
  appointment_id: string;
  specialty_id?: string;
}

export interface SendInviteResponse {
  sender_id: string;
  cellphone_e164: string;
  flow_type: string;
  state: string;
  template_name: string;
}

export async function sendBookingInvite(
  data: SendBookingInviteRequest
): Promise<SendInviteResponse> {
  const res = await authorizedFetch(`${API_BASE_URL}/api/v1/public/scheduling/send-booking-invite`, {
    method: 'POST',
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw Object.assign(new Error(err.detail || 'Erro ao enviar convite de agendamento.'), { status: res.status });
  }
  return res.json();
}

export async function sendRebookingInvite(
  data: SendRebookingInviteRequest
): Promise<SendInviteResponse> {
  const res = await authorizedFetch(`${API_BASE_URL}/api/v1/public/scheduling/send-rebooking-invite`, {
    method: 'POST',
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw Object.assign(new Error(err.detail || 'Erro ao enviar convite de reagendamento.'), { status: res.status });
  }
  return res.json();
}
